import React, { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Input from 'components/Input';
import classnames from 'classnames/bind';
import styles from './WelcomeBackModal.module.scss';
import Select, { components } from 'react-select';
import Typography from 'components/Typography';

// icons
import { ReactComponent as IndicatorIcon } from 'icons/chevron.svg';
import { min, pad } from 'lodash';

const cx = classnames.bind(styles);

const NameForm = () => {
  const customStyles = {
    option: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      border: `1px solid #a0a2af`,
      borderTop: 'none',
      color: 'black',
      cursor: 'pointer',
      transition: 'all .2s ease',
      '&:hover': {
        backgroundColor: '#F3F3F5',
      },
      padding: '2px 5px',
    }),
    control: (provided, state) => ({
      ...provided,
      width: 'fit-content',
      border: `1px solid #a0a2af`,
      borderRadius: '0',
      transition: 'boxShadow .2s ease',
      boxShadow: state.menuIsOpen ? '0px 4px 8px rgba(0, 0, 0, 0.25)' : 'none',
      '&:hover': {
        borderColor: '#a0a2af',
      },
      padding: '0 16px 0 0px',
      cursor: 'pointer',
      minHeight: '50px',
    }),
    menu: (provided) => ({
      ...provided,
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
      margin: 0,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    indicatorSeparator: () => ({}),
    indicatorContainer: (provided) => ({
      ...provided,
      padding: '0',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '18px',
      padding: '0',
    }),
  };

  const DropdownIndicator = (dprops) => (
    <components.DropdownIndicator {...dprops}>
      <IndicatorIcon
        className={cx('indicator-icon', {
          open: dprops.selectProps.menuIsOpen,
        })}
      />
    </components.DropdownIndicator>
  );

  const Option = (oprops) => (
    <components.Option {...oprops}>
      <div className={cx('option-wrapper')}>
        <div role="row" className={cx('option')}>
          <Typography className={cx('name')} title={oprops.data?.label}>
            {oprops.data?.label}
          </Typography>
        </div>
      </div>
    </components.Option>
  );

  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  const { first_name, last_name, title, email } = useSelector(({ user }) => user);

  const options = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Mx', label: 'Mx' },
  ];

  return (
    <>
      <div className={cx('columns')}>
        <div className={cx('select-wrapper')}>
          <Typography className={cx('name', 'mgb-5')}>
            Select Title<span className="red">*</span>
          </Typography>
          <Controller
            name="title"
            control={control}
            defaultValue={title}
            render={({ field, fieldState: { error } }) => (
              <>
                <Select
                  {...field}
                  styles={customStyles}
                  options={options}
                  components={{ DropdownIndicator, Option }}
                  isSearchable={false}
                  placeholder="Title"
                  value={options.find((option) => option.value === field.value)} // Find the selected option by value
                  onChange={(val) => field.onChange(val.value)} // Return only the value on change
                  required
                  className={error ? cx('has-error') : ''} // Add 'error' class if there is an error
                />
                {error && <Typography className={cx('error')}>{error.message}</Typography>}
              </>
            )}
          />
        </div>

        <Input
          label="First Name"
          name="first_name"
          defaultValue={first_name}
          inputRef={register('first_name', { required: true })}
          errors={errors}
        />
      </div>

      <Input
        label="Last Name"
        name="last_name"
        defaultValue={last_name}
        inputRef={register('last_name', { required: true })}
        errors={errors}
      />
      <Input
        type="email"
        label="Email"
        name="email"
        defaultValue={email}
        inputRef={register('email', { required: true })}
        errors={errors}
      />
      <Input
        className={cx('email_optin')}
        type="checkbox"
        label="I would like to receive occasional email updates about Mission US."
        name="email_optin"
        inputRef={register('email_optin', { required: false })}
        errors={errors}
        isCheckbox={true}
        isRequired={false}
        hasMarginBottom={false}
      />
    </>
  );
};

export default NameForm;
